import React from 'react';
import { Link } from 'react-router-dom';
import { Factory } from 'lucide-react';
import { mediaUrl } from '../services/api';

export default function BrandCard({ brand, onClick, className = '' }) {
  const content = <>
    <span className="brand-card-logo">
      {brand.logo_url ? <img src={mediaUrl(brand.logo_url)} alt="" loading="lazy" /> : <Factory aria-hidden="true" />}
    </span>
    <span className="brand-card-name">{brand.name || brand.title}</span>
  </>;
  return onClick ? (
    <button type="button" className={`brand-card ${className}`} onClick={onClick}>{content}</button>
  ) : (
    <Link to={`/brand/${brand.slug}`} className={`brand-card ${className}`}>{content}</Link>
  );
}
